import React from 'react'
import FormRichiestaCatalogo from '../../organisms/FormRichiestaCatalogo/FormRichiestaCatalogo'

const RichiestaCatalogoTemplate = (props) => {
  const cataloghi = props.cataloghi
  return (
    <div>
      <FormRichiestaCatalogo cataloghi={cataloghi} page={props.page} />
    </div>
  )
}

export default RichiestaCatalogoTemplate
